import React, { useState } from 'react';
import { useLocale, useMonthFormat } from '../../context/LocaleContext';
import s from './SummaryHeader.module.css';

// The twelve months by their short names in the studio's Region (#534): `Jan`
// .. `Dec` in English, `Jan` .. `Dez` in German.
const MONTHS = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));

function MonthPicker({ value, onChange, onClose }) {
  const { formatMonthShort } = useLocale();
  const [year, setYear] = useState(Number(value.split('-')[0]));
  return (
    <>
      <div className={s.scrim} onClick={onClose} />
      <div className={s.pop}>
        <div className={s.popHead}>
          <span className={s.year}>{year}</span>
          <button className={s.nav} onClick={() => setYear((v) => v - 1)} aria-label="Previous year">‹</button>
          <button className={s.nav} onClick={() => setYear((v) => v + 1)} aria-label="Next year">›</button>
        </div>
        <div className={s.months}>
          {MONTHS.map((m, i) => {
            const ym = `${year}-${m}`;
            const on = ym === value;
            return (
              <button
                key={m}
                className={[s.month, on ? s.monthOn : ''].filter(Boolean).join(' ')}
                onClick={() => { onChange(ym); onClose(); }}
              >
                {formatMonthShort(`${ym}-01`)}
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}

// "Accrual summary for August 2026" — the basis and the month, both editable.
export default function SummaryHeader({ basis, onBasisChange, month, onMonthChange }) {
  const [open, setOpen] = useState(false);
  // The studio's locale, not the browser's, and still on the UTC grid inside
  // formatMonthYear — these are UTC midnights, and reading one locally rolls it
  // back a day and, on the 1st, a whole month.
  const monthName = useMonthFormat();
  return (
    <div className={s.head}>
      <select className={`${s.link} ${s.basis}`} value={basis} onChange={(e) => onBasisChange(e.target.value)}>
        <option value="cash">Cash Flow</option>
        <option value="accrual">Accrual</option>
      </select>
      <span>summary for</span>
      <span className={s.anchor}>
        <button className={s.link} onClick={() => setOpen((v) => !v)}>{monthName(month)} ▾</button>
        {open ? (
          <MonthPicker value={month} onChange={onMonthChange} onClose={() => setOpen(false)} />
        ) : null}
      </span>
    </div>
  );
}
